import createSagaMiddleware from "@redux-saga/core"
import { configureStore } from "@reduxjs/toolkit"
import rootReducer from './reducers/rootReducer'
import dataSaga from "./middlewares/dataSaga/dataSaga"



export const createStore = (data) => {
  const preloadedState = {
    ...data
  }

  const sagaMiddleware = createSagaMiddleware()

  const appStore = configureStore({
      reducer: rootReducer,
      middleware: getDefaultMiddleware =>
          getDefaultMiddleware({
            thunk: false,
      }).concat(sagaMiddleware),
      preloadedState
  })

  sagaMiddleware.run(dataSaga)

  return appStore
}